import { Component, DestroyRef, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { catchError, of, tap } from 'rxjs';
import { User } from '../../core/models/user.model';
import { AuthenticationService } from '../../core/services/authentication.service';
import { NavigationService } from '../../core/services/navigation.service';
import { UserStateService } from '../../core/services/user.state.service';
import { PATHS } from '../../shared/models/paths';
import { JsonPipe, NgOptimizedImage } from '@angular/common';
import { StorageStateService } from '../../core/services/storage-state.service';

@Component({
  selector: 'dnv-navigation',
  imports: [
    TranslatePipe,
    NgOptimizedImage,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatIconButton,
    MatMenuTrigger,
    JsonPipe,
  ],
  templateUrl: './navigation.component.html',
})
export class NavigationComponent {
  public readonly user = input<User | null>();

  private readonly authenticationService = inject(AuthenticationService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly navigationService = inject(NavigationService);
  private readonly userStateService = inject(UserStateService);
  protected readonly storageStateService = inject(StorageStateService);

  public async signOut() {
    this.authenticationService
      .signOut()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => this.userStateService.user.set(null)),
        tap(() => this.navigationService.navigate(PATHS.signIn())),
        catchError((error) => {
          console.error(error);
          return of(error);
        }),
      )
      .subscribe();
  }
}
